<template>
  <v-row>
    <v-col
      v-if="!isLoading"
      cols="12"
    >
      <app-card-code :title="`${$t('menu.products')} / ${$t('menu.cars')} / ${$t('menu.export')}`">
        <Form
          :is-table="isTable"
          ruta-back="cars-list"
          :tabla="tabla"
          :campos-entity-list="camposEntityList"
          :marcas-cars="marcasCars"
          :transmisiones="transmisiones"
          :type-auto="typeAuto"
          :combustibles="combustibles"
          :caracteristicas="caracteristicas"
        />
      </app-card-code>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// eslint-disable-next-line import/no-unresolved
import Form from '@/views/utils/exportations/form/Form.vue'

export default {
  components: {
    AppCardCode,
    Form,
  },
  data() {
    return {
      isLoading: true,
      tabla: {
        name: 'Autos',
        tabla: 'cars',
        campos: [],
      },
      user: {},

      isTable: false,
      entitiesList: [],
      camposEntityList: [],
      marcasCars: [],
      transmisiones: [],
      typeAuto: [],
      combustibles: [],
      caracteristicas: [],
    }
  },
  mounted() {
    this.profile()
  },
  created() {
    this.getEntities()

    // NOM CARS
    this.getMarcas()
    this.getTransmisiones()
    this.getTypeAuto()
    this.getCombustibles()
    this.getCaracteristicas()
  },
  methods: {
    profile() {
      this.axios
        .get(`${process.env.VUE_APP_API_URL}profile`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(response => {
          // eslint-disable-next-line no-empty
          if (response.data.success === false) {
          }
          this.user = response.data.data
        })
        .catch(error => console.log(error))
        // eslint-disable-next-line no-return-assign
        .finally(() => {
          this.isLoading = false

          // this.isLoading = false
        })
    },

    getEntities() {
      this.axios
        .get('export-csv/list', {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          if (res.data.success) {
            this.entitiesList = res.data.data.list

            this.isTable = true
            const result = this.entitiesList.filter(e => e.tabla === this.tabla.tabla)[0]
            this.camposEntityList = result.campos
          }
        })
    },

    // NOMENCLADORES AUTOS
    getMarcas() {
      this.axios
        .get(`nom_marca_cars?per_page=1000&perfil_slug=${sessionStorage.getItem('perfil')}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          this.marcasCars = res.data.data
        })
    },
    getTransmisiones() {
      this.axios
        .get(`nom_transmision_cars?per_page=1000&perfil_slug=${sessionStorage.getItem('perfil')}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          this.transmisiones = res.data.data
        })
    },
    getTypeAuto() {
      this.axios
        .get(`nom_type_auto_cars?per_page=1000&perfil_slug=${sessionStorage.getItem('perfil')}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          this.typeAuto = res.data.data
        })
    },
    getCombustibles() {
      this.axios
        .get(`nom_combustible_cars?per_page=1000&perfil_slug=${sessionStorage.getItem('perfil')}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          this.combustibles = res.data.data
        })
    },
    getCaracteristicas() {
      this.axios
        .get(`nom_caracteristica_cars?per_page=1000&perfil_slug=${sessionStorage.getItem('perfil')}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          this.caracteristicas = res.data.data
        })
    },
  },
}
</script>
